/* eslint-disable @nx/enforce-module-boundaries */
import { ChevronDownNew } from '@mybridge/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDisclosure } from '@mybridge/ui/hooks';
import { Input, InputGroup, InputRightElement } from '@mybridge/ui/input';
import { List, ListItem } from '@mybridge/ui/list';
import {
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from '@mybridge/ui/popover';
import { useRef, useState } from 'react';

export const CustomEmailDropdown = ({
  value,
  defaultValue,
  onChange,
  clearOnSelect = false,
  allowCreate = true,
  children,
  keyName = 'name',
  onSearch,
  isLoading,
  field,
  data = [],
  inputGroupProps,
  inputRElementProp,
  inputProps,
  onEscape,
  placeHolder,
  dropDownAerrow,
  website=false,
  ...props
}) => {

  const inputRef = useRef();
  const containerRef = useRef();
  const [search, setSearch] = useState(clearOnSelect ? '' : value);
  const disc = useDisclosure();
  const [selected, setSelected] = useState();
  const tid = useRef(-1);
  const { t } = useTranslator();

  const handleSelect = (item) => () => {
    onSelect(item);
  };

  const onSelect = (item) => {
    if (item) {
      setSelected(item);
      setSearch(clearOnSelect ? '' : item?.[keyName]);
      onSearch?.(clearOnSelect ? '' : item?.[keyName]);
      onChange(field ? item?.[field] : item);
      disc?.onClose?.();
    }
  };
 // Unified validation function
const validateInput = (input) => {
    const re = website
      ? /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/
      : /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    return re.test(String(input).toLowerCase());
  };
  const onSearchChange = (val) => {
    setSearch(val);
    onSearch?.(val);
  };

  const onKeyDown = (e) => {
    if (e.keyCode !== 13 && e.keyCode !== 27) return;
    e.preventDefault?.();
    e.stopPropagation?.();
  };

  const onKeyUp = (e) => {
    e.preventDefault?.();
    e.stopPropagation?.();
    
    const inputValue = e.target?.value;
  
    // Apply validation based on the unified validation function
    if (!validateInput(inputValue)) {
      console.error('Invalid input');
      return; // Do not proceed if validation fails
    }
  
    if (e.keyCode === 27) {
      inputRef.current.value = '';
      onEscape?.();
      return;
    }
  
    if (e.keyCode === 13) {
      onChange?.(field ? inputValue : { [keyName]: inputValue });
      inputRef.current.value = '';
      return;
    }
  
    disc?.onOpen?.();
  };

  // useEffect(() => {
  //   if (value !== search) {
  //     setSearch(value);
  //   }
  // }, [value]);

  return (
    <Popover
      {...disc}
      ref={containerRef}
      matchWidth={true}
      initialFocusRef={inputRef}
      placement="bottom-start"
    >
      <PopoverTrigger>
        <InputGroup {...(inputGroupProps ?? {})}>
          {/* {isLoading ? (
            <InputRightElement
              h={props?.variant === 'greyRounded' ? '36px' : '40px'}
            >
              <Spinner />
            </InputRightElement>
          ) : (
            <InputRightElement
              onClick={(e) => {
                onSearchChange(inputRef?.current?.value ?? '');
              }}
              h={props?.variant === 'greyRounded' ? '36px' : '40px'}
            >
              <ChevronDownNew width="24" height="24" />
            </InputRightElement>
          )} */}
          {dropDownAerrow && (
            <InputRightElement
              onClick={(e) => {
                onSearchChange(inputRef?.current?.value ?? '');
              }}
              h={props?.variant === 'greyRounded' ? '36px' : props?.variant === 'whiteInput' ? '60px' : '40px'}
            >
              <ChevronDownNew width="24" height="24" />
            </InputRightElement>
          )}
          
          {children ? (
            children?.({
              inputRef,
              ref: inputRef,
              value: search,
              disc,
              onChange: onSearchChange,
              onKeyUp,
              onKeyDown,
            })
          ) : (
            <Input
              placeHolder={placeHolder ? placeHolder : "select"}
              ref={inputRef}
              value={search}
              onKeyUp={onKeyUp}
              onKeyDown={onKeyDown}
              onClick={(e) => disc?.onOpen?.()}
              onChange={(e) => onSearchChange(e.target.value)}
              {...props}
              {...inputProps}
            />
          )}
        </InputGroup>
      </PopoverTrigger>
      {disc?.isOpen &&validateInput(search)&&(search?.length > 0 || data?.length > 0) ? (
        <PopoverContent p={0} w="100%" maxH="200px" overflowY="auto">
          {!allowCreate && isLoading ? (
            ''
          ) : (
            <PopoverBody p={0}>
              <List>
                {allowCreate && search?.length > 0 ? (
                  <ListItem
                    _hover={{
                      bg: 'gray.100',
                    }}
                    px={4}
                    py={2}
                    onClick={handleSelect({ [keyName]: search })}
                  >
                    {t('myDisk.create') || "Create"} &quot;{search}&quot;
                  </ListItem>
                ) : (
                  ''
                )}
                {!isLoading && data?.length > 0
                  ? data
                      ?.filter?.((c) =>
                        c?.[keyName]
                          ?.toLowerCase?.()
                          ?.includes(search?.toLowerCase?.())
                      )
                      ?.map?.((c, cind) => (
                        <ListItem
                          key={cind}
                          _hover={{
                            bg: 'gray.100',
                          }}
                          px={4}
                          py={2}
                          onClick={handleSelect(c)}
                        >
                          {c?.[keyName]}
                        </ListItem>
                      ))
                  : ''}
              </List>
            </PopoverBody>
          )}
        </PopoverContent>
      ) : (
        ''
      )}
    </Popover>
  );
};
